/* tslint:disable */
/* eslint-disable */
/**
 * BackendFramework
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { CustomField } from "./custom-field";
import { OffOnSetting } from "./off-on-setting";
import { SemanticDomainFull } from "./semantic-domain-full";
import { WritingSystem } from "./writing-system";

/**
 *
 * @export
 * @interface Project
 */
export interface Project {
  /**
   *
   * @type {string}
   * @memberof Project
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof Project
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof Project
   */
  created?: string | null;
  /**
   *
   * @type {boolean}
   * @memberof Project
   */
  isActive: boolean;
  /**
   *
   * @type {boolean}
   * @memberof Project
   */
  liftImported: boolean;
  /**
   *
   * @type {boolean}
   * @memberof Project
   */
  definitionsEnabled: boolean;
  /**
   *
   * @type {boolean}
   * @memberof Project
   */
  grammaticalInfoEnabled: boolean;
  /**
   *
   * @type {OffOnSetting}
   * @memberof Project
   */
  autocompleteSetting: OffOnSetting;
  /**
   *
   * @type {OffOnSetting}
   * @memberof Project
   */
  harvesterReviewEntriesEnabled: OffOnSetting;
  /**
   *
   * @type {OffOnSetting}
   * @memberof Project
   */
  protectedDataMergeAvoidEnabled: OffOnSetting;
  /**
   *
   * @type {OffOnSetting}
   * @memberof Project
   */
  protectedDataOverrideEnabled: OffOnSetting;
  /**
   *
   * @type {WritingSystem}
   * @memberof Project
   */
  semDomWritingSystem: WritingSystem;
  /**
   *
   * @type {WritingSystem}
   * @memberof Project
   */
  vernacularWritingSystem: WritingSystem;
  /**
   *
   * @type {Array<WritingSystem>}
   * @memberof Project
   */
  analysisWritingSystems: Array<WritingSystem>;
  /**
   *
   * @type {Array<SemanticDomainFull>}
   * @memberof Project
   */
  semanticDomains: Array<SemanticDomainFull>;
  /**
   *
   * @type {Array<string>}
   * @memberof Project
   */
  validCharacters: Array<string>;
  /**
   *
   * @type {Array<string>}
   * @memberof Project
   */
  rejectedCharacters: Array<string>;
  /**
   *
   * @type {Array<CustomField>}
   * @memberof Project
   */
  customFields?: Array<CustomField> | null;
  /**
   *
   * @type {Array<string>}
   * @memberof Project
   */
  wordFields?: Array<string> | null;
  /**
   *
   * @type {Array<string>}
   * @memberof Project
   */
  partsOfSpeech?: Array<string> | null;
  /**
   *
   * @type {Array<string>}
   * @memberof Project
   */
  workshopSchedule?: Array<string> | null;
}
